;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/auth/login\"},{\"path\":\"/auth/verify\"},{\"path\":\"/coupon\"},{\"path\":\"/download-app\"},{\"path\":\"/home\"},{\"path\":\"/privacy\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/subscription/cashfree\"},{\"path\":\"/terms\"},{\"path\":\"/v10\"},{\"path\":\"/v11\"},{\"path\":\"/v12\"},{\"path\":\"/v13\"},{\"path\":\"/v14\"},{\"path\":\"/v3\"},{\"path\":\"/v4\"},{\"path\":\"/v5\"},{\"path\":\"/v6\"},{\"path\":\"/v7\"},{\"path\":\"/v8\"},{\"path\":\"/v9\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.7";import * as Sentry from "@sentry/nextjs";

if ((process.env.NODE_ENV as string) !== 'production') {
    console.log("💎 [Sentry] instrumentation-client.ts is executing...");
}

Sentry.init({
    // Hardcoded DSN for guaranteed initialization on static sites
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

    // Adds request headers and IP for users
    sendDefaultPii: true,

    // Performance monitoring - targeted sampling instead of flat rate
    tracesSampler: (samplingContext) => {
        const name = samplingContext.name || "";
        const attributes = samplingContext.attributes || {};
        const url = typeof attributes.url === "string" ? attributes.url : "";

        // Capture 100% of payment/subscription related transactions
        if (
            name.includes("premiumPlan") ||
            name.includes("razorpay") ||
            name.includes("createSubscription") ||
            name.includes("subscription") ||
            url.includes("premiumPlan") ||
            url.includes("razorpay")
        ) {
            return 1.0;
        }

        // Everything else: 100% in dev, 10% in production
        return process.env.NODE_ENV === "development" ? 1.0 : 0.1;
    },

    replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.02 : 0,
    replaysOnErrorSampleRate: process.env.NODE_ENV === 'production' ? 1.0 : 0,

    integrations: [],
    enableLogs: process.env.NODE_ENV !== "production",
    debug: process.env.NODE_ENV !== "production",

    // Set enabled to true for testing
    enabled: process.env.NODE_ENV === "production",

    // Production-grade Noise Reduction
    denyUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome-extension:\/\//i,
        // Adblockers
        /adblock/i,
        /brave/i,
        // Common analytics noise
        /moengage/i,
    ],

    ignoreErrors: [
        "Inpage", // Common extension error
        "Brave",
        "Non-Error promise rejection captured",
    ],

    // Production-call Data Privacy (PII Scrubbing)
    beforeSend(event) {
        if (event.request?.headers) {
            // Scrub sensitive headers
            delete event.request.headers["Authorization"];
            delete event.request.headers["Cookie"];
            delete event.request.headers["key"]; // Your app's secret key
        }
        return event;
    },

    // Filter or modify logs before they're sent
    beforeSendLog(log) {
        if (process.env.NODE_ENV === "production" && log.level === "debug") {
            return null;
        }

        // Scrub password-like attributes from logs
        if (log.attributes) {
            const sensitiveKeys = ["password", "token", "otp"];
            for (const key of sensitiveKeys) {
                if (log.attributes[key]) log.attributes[key] = "[SCRUBBED]";
            }
        }
        return log;
    },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
